import {LinkUserData} from "../../../../types/Link";
import {useState} from "react";
import LinkForm from "./LinkForm";
import {Button, Stack, Table} from "react-bootstrap";
import {StringUtil} from "zavadil-ts-common";

export type NodeEditLinksProps = {
	links: Array<LinkUserData>;
	onChange: (links: Array<LinkUserData>) => void;
}

export default function NodeEditLinks({links, onChange}: NodeEditLinksProps) {
	const [editLink, setEditLink] = useState<LinkUserData | null>(null);
	const [selectedLink, setSelectedLink] = useState<LinkUserData | null>(null);

	return (
		<div>
			<Stack direction="horizontal" gap={2}>
				<Button
					variant="success"
					onClick={
						() => {
							setEditLink(
								{
									id: null,
									url: '',
									name: '',
									description: null
								}
							);
						}
					}
				>přidat</Button>
				<Button
					variant="primary"
					disabled={selectedLink === null}
					onClick={() => setEditLink(selectedLink)}
				>upravit</Button>
				<Button
					variant="danger"
					disabled={selectedLink === null}
					onClick={
						() => {
							onChange(
								links.filter((l) => l !== selectedLink)
							);
						}
					}
				>smazat</Button>
			</Stack>
			<Table>
				<thead>
				<tr>
					<th>URL</th>
					<th>Název</th>
					<th>Popis</th>
				</tr>
				</thead>
				<tbody>
				{
					links.map(
						(link, index) => <tr
							key={index}
							onClick={() => setSelectedLink(link)}
							onDoubleClick={() => setEditLink(link)}
							className={selectedLink === link ? 'active' : ''}
						>
							<td className="no-select">{StringUtil.ellipsis(link.url, 20)}</td>
							<td className="no-select">{link.name}</td>
							<td className="no-select">{StringUtil.ellipsis(link.description, 20)}</td>
						</tr>
					)
				}
				</tbody>
			</Table>
			{
				editLink !== null && <LinkForm
					link={editLink}
					onClosed={() => setEditLink(null)}
					onSaved={
						(link) => {
							if (links.includes(editLink)) {
								onChange(links.map((l) => l === editLink ? link : l));
							} else {
								onChange([...links, link]);
							}
							setEditLink(null);
						}
					}
				/>
			}
		</div>
	);
}
